import log from "logbeacon";

export type NotificationSyncStage =
  | "write_upsert"
  | "pull_snapshot"
  | "realtime_event"
  | "session_refresh";

type TelemetryPayload = {
  ownerId?: string;
  table?: string;
  event?: string;
  lagMs?: number;
  status?: string;
  reason?: string;
  extra?: Record<string, unknown>;
};

const NOTIFICATION_SYNC_DEBUG_KEY = "notification_sync_debug";
const VERBOSE_ENVS = new Set(["dev", "beta", "pre"]);

function isEnvVerbose(): boolean {
  const env = process.env.NEXT_PUBLIC_ENV ?? "";
  return VERBOSE_ENVS.has(env);
}

function isDebugEnabledByStorage(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    const flag = window.localStorage.getItem(NOTIFICATION_SYNC_DEBUG_KEY);
    return flag === "1" || flag === "true";
  } catch {
    return false;
  }
}

function shouldOutputSyncLog(): boolean {
  return isEnvVerbose() || isDebugEnabledByStorage();
}

export function isNotificationSyncDebugEnabled(): boolean {
  if (shouldOutputSyncLog()) {
    return true;
  }
  if (typeof window === "undefined") {
    return false;
  }
  return Boolean(
    (window as Window & { __NOTIFY_SYNC_DEBUG__?: boolean })
      .__NOTIFY_SYNC_DEBUG__,
  );
}

export function logNotificationSync(
  stage: NotificationSyncStage,
  payload: TelemetryPayload,
): void {
  if (!shouldOutputSyncLog()) {
    return;
  }

  log.info("[notification][sync]", {
    stage,
    ownerId: payload.ownerId,
    table: payload.table,
    event: payload.event,
    lagMs: payload.lagMs,
    status: payload.status,
    reason: payload.reason,
    ...payload.extra,
  });
}
